export const ROLL_REQUEST_EVENT = "roll_request";
export const ROLL_RESULT_EVENT = "roll_result";
export const ROOM_WELCOME_EVENT = "room_welcome";
export const USER_CONNECTED_EVENT = "user_connected";
export const USER_DISCONNECTED_EVENT = "user_disconnected";
